// Import game images from shared assets
import beatDecodersImg from '../../../shared/assets/images/games/Beat Decoder Thumbnail.png';
import harmonyVotersStudentImg from '../../../shared/assets/images/games/Harmonidome Student Thumbnail.png';
import harmonyVotersTeacherImg from '../../../shared/assets/images/games/Harmonidome Teacher Thumbnail.png';
import melopedeCavesImg from '../../../shared/assets/images/games/Melopede Caves Thumbnail.png';
import pianoClickerImg from '../../../shared/assets/images/games/Piano Clicker Thumbnail.png';
import reactAttackStudentImg from '../../../shared/assets/images/games/React Attack Student Thumbnail.png';
import reactAttackTeacherImg from '../../../shared/assets/images/games/React Attack Teacher Thumbnail.png';
import realOrAiImg from '../../../shared/assets/images/games/Real Or AI Thumbnail.png';
import chordstructionImg from '../../../shared/assets/images/games/Chordstruction Thumbnail.png';
import scaleImg from '../../../shared/assets/images/games/Scale The Tower Thumbnail.png';
import rhythmRallyImg from '../../../shared/assets/images/games/Rhythm Rally Thumbnail.png';
import rocketRaceImg from '../../../shared/assets/images/games/rocketrace.png';
import tuna from "../../../shared/assets/images/games/Tuna Thumbnail.png";
// import songlyImg from '../../../shared/assets/images/games/songly.png';
  import yeetTheScoopImg from '../../../shared/assets/images/games/Yeet The Scoop Thumbnail.png';
  import myFavoriteMusiciansImg from '../../../shared/assets/images/games/my_favorite_musicians.png';
  import overtureMusicLabImg from '../../../shared/assets/images/games/Overture Music Lab Thumbnail.png';
import { 
  RhythmPuzzle,
  KahootRhythm as kahootImg,
  InstrumentsInVideos as instrumentsInVideosImg,
  InstrumentFamilies as instrumentFamiliesImg,
  Incredibox as incrediboxImg,
  Rhythm101 as insideOrchestraImg
} from '../../../shared/assets/images/activities';
import soundGymImg from '../../../shared/assets/images/activities/soundgym.png';
import sunoImg from '../../../shared/assets/images/activities/Suno_activity.png';
  import stepSkipRepeatImg from '../../../shared/assets/images/games/Step_Skip_Repeat.png';
  import tuneTestersImg from '../../../shared/assets/images/activities/tune_testers.png';
  import melodyShaperImg from '../../../shared/assets/images/games/Melody_Shaper.png';
import flappyMuseImg from '../../../shared/assets/images/games/flappy_muse.png';
import harmonidomeLabImg from '../../../shared/assets/images/games/Harmonidome Lab Thumbnail.png';
import defaultGameImage from '../../../shared/assets/images/games/default-game.png';
import snakeArcadeImg from '../../../shared/assets/images/games/snake_arcade.svg';
import dinoDashImg from '../../../shared/assets/images/games/dino_dash.svg';
import skyFlapImg from '../../../shared/assets/images/games/sky_flap.svg';
import homeRunHeroImg from '../../../shared/assets/images/games/home_run_hero.svg';
import gemMatchImg from '../../../shared/assets/images/games/gem_match_v2.png';
import humanControllerImg from '../../../shared/assets/images/games/human_controller_v2.png';
import playerShowdownImg from '../../../shared/assets/images/games/player_showdown_v2.png';
import gameFeelLabImg from '../../../shared/assets/images/games/game_feel_lab_v2.png';
import greatBugHuntImg from '../../../shared/assets/images/games/great_bug_hunt.png';
import characterLabImg from '../../../shared/assets/images/games/Character Lab Thumbnail.png';
import storyboardStudioImg from '../../../shared/assets/images/games/storyboard_studio.svg';

export interface GameConfig {
  id: string;
  title: string;
  description: string;
  like?: string;
  type: 'unity' | 'vanilla' | 'iframe';
  gameUrl?: string;
  buildPath?: string;
  thumbnail: string;
  category: 'rhythm' | 'harmony' | 'melody' | 'composition' | 'general' | 'form' | 'instruments' | 'dynamics';
  difficulty: 'easy' | 'medium' | 'hard';
  cashReward: number;
  estimatedPlayTime: number; // in minutes
  status: 'active' | 'beta' | 'maintenance' | 'coming_soon';
  features?: string[];
  requiresLogin: boolean;
  gameMode: 'social-clubhouse' | 'solo-leveling' | 'both' | 'teacher-led' | 'single-player';
  tier: 'premium' | 'basic' | 'core';
  playerCount: {
    min: number;
    max: number;
  } | 'single-player';
  musicalElements: ('harmony' | 'instruments' | 'melody' | 'form' | 'rhythm' | 'dynamics')[];
  musicalSkills: ('performance' | 'improvisation' | 'composition' | 'ear-training')[];
}

export type GameCurriculum = 'music' | 'video-game-design' | 'movie-making';

const VIDEO_GAME_DESIGN_GAME_IDS = new Set([
  'neon-snake',
  'dino-dash',
  'human-controller',
  'game-feel-lab',
  'great-bug-hunt',
  'player-showdown',
  'emoji-match',
  'home-run-hero',
  'sky-flap',
  'character-lab',
]);

export const getGameCurricula = (gameId: string): GameCurriculum[] => {
  if (gameId === 'real-or-ai') return ['music', 'video-game-design'];
  if (gameId === 'storyboard-studio' || gameId === 'spot-the-difference') return ['movie-making'];
  return VIDEO_GAME_DESIGN_GAME_IDS.has(gameId) ? ['video-game-design'] : ['music'];
};

export const GAME_REGISTRY: Record<string, GameConfig> = {
  // Unity Games - Using actual folder names and index.html files
  'rhythm-rally': {
    id: 'rhythm-rally',
    title: 'Rhythm Rally',
    description: 'Hit notes in time with the beat.',
    like: 'Friday Night Funkin',
    type: 'unity',
    gameUrl: '/games/RhythmRally/index.html',
    thumbnail: rhythmRallyImg,
    category: 'rhythm',
    difficulty: 'medium',
    cashReward: 75,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Rhythm Practice', 'Beat Recognition', 'Timing Skills'],
    requiresLogin: false,
    gameMode: 'both',
    tier: 'core',
    playerCount: { min: 1, max: 4 },
    musicalElements: ['rhythm'],
    musicalSkills: ['performance'],
  },

  'beat-decoders': {
    id: 'beat-decoders',
    title: 'Beat Decoder',
    description: 'Crack patterns to build cool rhythms.',
    like: 'Garage Band',
    type: 'unity',
    gameUrl: '/gcs-games/beat-decoder/index.html',
    thumbnail: beatDecodersImg,
    category: 'rhythm',
    difficulty: 'hard',
    cashReward: 75,
    estimatedPlayTime: 6,
    status: 'active',
    features: ['Pattern Recognition', 'Beat Building', 'Rhythm Fundamentals'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: { min: 1, max: 1 },
    musicalElements: ['rhythm'],
    musicalSkills: ['composition'],
  },

  'rocket-race': {
    id: 'rocket-race',
    title: 'Rocket Race',
    description: 'Race your rocket by answering music theory questions at high speed!',
    like: 'Blooket for Music',
    type: 'unity',
    gameUrl: '/games/RocketRace/index.html',
    thumbnail: rocketRaceImg,
    category: 'general',
    difficulty: 'medium',
    cashReward: 20,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Quiz Game', 'Competitive', 'Teacher-Led'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: { min: 1, max: 200 },
    musicalElements: ['harmony', 'instruments', 'rhythm', 'dynamics', 'melody', 'form'],
    musicalSkills: ['performance'],
  },

  'yeet-the-scoop': {
    id: 'yeet-the-scoop',
    title: 'Yeet the Scoop',
    description: 'Deliver ice cream by identifying major and minor chords.',
    like: "Papa's Freezaria",
    type: 'unity',
    gameUrl: '/games/YeetTheScoop/index.html',
    thumbnail: yeetTheScoopImg,
    category: 'harmony',
    difficulty: 'medium',
    cashReward: 25,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Fast-Paced', 'Chord Recognition'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['harmony'],
    musicalSkills: ['composition', 'performance'],
  },

  'melopedes': {
    id: 'melopedes',
    title: 'Melopede Caves',
    description: 'Arrange melody bugs to compose tunes.',
    like: 'Fishdom',
    type: 'unity',
    gameUrl: '/games/Melopedes/index.html',
    thumbnail: melopedeCavesImg,
    category: 'melody',
    difficulty: 'hard',
    cashReward: 75,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Melody Creation', 'Composition Skills', 'Pattern Recognition'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: { min: 1, max: 1 },
    musicalElements: ['melody'],
    musicalSkills: ['composition'],
  },

  'harmonidome-teacher': {
    id: 'harmonidome-teacher',
    title: 'Harmonidome (Teacher)',
    description: 'Teachers guide class harmony battles.',
    like: 'March Madness',
    type: 'unity',
    gameUrl: '/games/HarmonyVotersTeacher/index.html',
    thumbnail: harmonyVotersTeacherImg,
    category: 'harmony',
    difficulty: 'easy',
    cashReward: 100,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Teacher Tools', 'Student Guidance', 'Musical Voting'],
    requiresLogin: false,
    gameMode: 'social-clubhouse',
    tier: 'core',
    playerCount: { min: 2, max: 100 },
    musicalElements: ['harmony', 'instruments'],
    musicalSkills: ['performance'],
  },

  'harmonidome': {
    id: 'harmonidome',
    title: 'Harmonidome (Student)',
    description: 'Students vote on the best harmonies.',
    like: 'March Madness',
    type: 'unity',
    gameUrl: '/games/HarmonyVotersStudents/index.html',
    thumbnail: harmonyVotersStudentImg,
    category: 'harmony',
    difficulty: 'easy',
    cashReward: 75,
    estimatedPlayTime: 6,
    status: 'active',
    features: ['Musical Voting', 'Music Appreciation', 'Student Learning'],
    requiresLogin: false,
    gameMode: 'social-clubhouse',
    tier: 'core',
    playerCount: { min: 2, max: 100 },
    musicalElements: ['harmony', 'instruments'],
    musicalSkills: ['performance'],
  },

  'react-attack-teacher': {
    id: 'react-attack-teacher',
    title: 'React Attack (Teacher)',
    description: 'Teach musical form with memes.',
    like: 'Make it Meme',
    type: 'unity',
    gameUrl: '/games/ReactAttackTeacher/index.html',
    thumbnail: reactAttackTeacherImg,
    category: 'form',
    difficulty: 'easy',
    cashReward: 75,
    estimatedPlayTime: 8,
    status: 'active',
    features: ['Meme Magic', 'Musical Form', 'Teacher Tools'],
    requiresLogin: false,
    gameMode: 'social-clubhouse',
    tier: 'core',
    playerCount: { min: 2, max: 100 },
    musicalElements: ['form'],
    musicalSkills: ['performance'],
  },

  'react-attack-student': {
    id: 'react-attack-student',
    title: 'React Attack (Student)',
    description: 'Learn musical form through memes.',
    like: 'Make it Meme',
    type: 'unity',
    gameUrl: '/games/ReactAttackStudent/',
    thumbnail: reactAttackStudentImg,
    category: 'form',
    difficulty: 'easy',
    cashReward: 75,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Meme Learning', 'Musical Form', 'Student Fun'],
    requiresLogin: false,
    gameMode: 'social-clubhouse',
    tier: 'core',
    playerCount: { min: 2, max: 100 },
    musicalElements: ['form'],
    musicalSkills: ['performance'],
  },

  // Vanilla JS Games - Using actual file paths
  'piano-clicker': {
    id: 'piano-clicker',
    title: 'Piano Clicker',
    description: 'Click piano keys to learn music basics.',
    like: 'Stimulation Clicker',
    type: 'vanilla',
    gameUrl: '/games/PianoClicker/index.html',
    thumbnail: pianoClickerImg,
    category: 'melody',
    difficulty: 'medium',
    cashReward: 75,
    estimatedPlayTime: 3,
    status: 'active',
    features: ['Music Theory', 'Melody Learning', 'Harmony Basics'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: { min: 1, max: 1 },
    musicalElements: ['melody', 'harmony'],
    musicalSkills: ['performance'],
  },

  'character-lab': {
    id: 'character-lab',
    title: 'Character Lab',
    description: 'Recognize favorite characters, compare 2D and 3D art, and find the joints that make characters move.',
    like: 'Interactive Classroom Quiz',
    type: 'vanilla',
    gameUrl: '/games/CharacterLab/index.html',
    thumbnail: characterLabImg,
    category: 'general',
    difficulty: 'easy',
    cashReward: 25,
    estimatedPlayTime: 8,
    status: 'active',
    features: ['Character Recognition', '2D vs 3D', 'Animation Joints', 'Teacher-Paced'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: { min: 1, max: 200 },
    musicalElements: ['form'],
    musicalSkills: ['performance'],
  },

  'tuna': {
    id: 'tuna',
    title: 'Tuna',
    description: 'Fly through the ocean and match the pitch to avoid obstacles, similar to Flappy Bird.',
    like: 'Jetpack Joyride',
    type: 'unity',
    gameUrl: '/games/Tuna/index.html',
    thumbnail: tuna,
    category: 'melody',
    difficulty: 'medium',
    cashReward: 100,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Pitch Matching', 'Obstacle Avoidance', 'Endless Runner'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['melody'],
    musicalSkills: ['ear-training'],
  },

  'real-or-ai': {
    id: 'real-or-ai',
    title: 'Real or AI',
    description: 'Can you tell the difference between a real image and an AI-generated one?',
    like: "Where's Waldo",
    type: 'iframe',
    gameUrl: '/games/RealOrAI/index.html',
    thumbnail: realOrAiImg,
    category: 'general',
    difficulty: 'medium',
    cashReward: 20,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Group Discussion', 'Visual Literacy', 'Modern Tech'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'premium',
    playerCount: { min: 2, max: 100 },
    musicalElements: [],
    musicalSkills: ['ear-training', 'performance'],
  },

  'neon-snake': {
    id: 'neon-snake', title: 'Neon Snake',
    description: 'Collect stars, grow your snake, and avoid crashing.',
    like: 'Snake', type: 'iframe', gameUrl: '/games/Snake/index.html', thumbnail: snakeArcadeImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 5, status: 'active',
    features: ['Quick Reactions', 'Planning', 'High Scores'], requiresLogin: false,
    gameMode: 'single-player', tier: 'basic', playerCount: 'single-player', musicalElements: [], musicalSkills: [],
  },

  'dino-dash': {
    id: 'dino-dash', title: 'Dino Dash',
    description: 'Jump over obstacles and run as far as you can.',
    like: 'Chrome Dino', type: 'iframe', gameUrl: '/games/DinoDash/index.html', thumbnail: dinoDashImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 5, status: 'active',
    features: ['Timing', 'Quick Reactions', 'High Scores'], requiresLogin: false,
    gameMode: 'single-player', tier: 'basic', playerCount: 'single-player', musicalElements: [], musicalSkills: [],
  },

  'human-controller': {
    id: 'human-controller', title: 'Blob Quest: Human Controller',
    description: 'Vote as a class to guide one blob through stars, obstacles, and changing abilities.',
    like: 'A whole-class puzzle', type: 'iframe', gameUrl: '/games/HumanController/index.html', thumbnail: humanControllerImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 8, status: 'active',
    features: ['Whole-Class Voting', 'Point and Click', 'AI Literacy'], requiresLogin: false,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 2, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'game-feel-lab': {
    id: 'game-feel-lab', title: 'Game Feel Lab',
    description: 'Change one setting, replay the same level, and discover how game feel changes the player experience.',
    like: 'A hands-on game design lab', type: 'iframe', gameUrl: '/games/GameFeelLab/index.html', thumbnail: gameFeelLabImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 12, status: 'active',
    features: ['Physics Experiments', 'Game Feel Presets', 'Class Predictions'], requiresLogin: false,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 1, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'great-bug-hunt': {
    id: 'great-bug-hunt', title: 'The Great Bug Hunt',
    description: 'Spot, locate, explain, and reproduce silly bugs in the blue blob platformer.',
    like: 'A whole-class debugging mystery', type: 'iframe', gameUrl: '/games/GreatBugHunt/index.html', thumbnail: greatBugHuntImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 15, status: 'active',
    features: ['Debugging Practice', 'Detective Mode', 'Whole-Class Play'], requiresLogin: false,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 2, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'player-showdown': {
    id: 'player-showdown', title: 'Creative Showdown',
    description: 'Create players or worlds, build a March Madness bracket, and let the class choose every winner.',
    like: 'March Madness', type: 'iframe', thumbnail: playerShowdownImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 12, status: 'active',
    features: ['Player & World Creation', 'Class Voting', 'Tournament Brackets'], requiresLogin: true,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 2, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'spot-the-difference': {
    id: 'spot-the-difference', title: 'Spot the Differences!',
    description: 'Explore two videos side by side, talk about what changed, and choose your favorite shot.',
    like: 'A movie detective challenge', type: 'iframe', gameUrl: '/games/SpotTheDifference/index.html', thumbnail: '/games/SpotTheDifference/thumbnail.svg',
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 12, status: 'active',
    features: ['Video Comparisons', 'Close-up Exploration', 'Discussion & Favorite Shots'], requiresLogin: false,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 1, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'storyboard-studio': {
    id: 'storyboard-studio', title: 'Storyboard Studio',
    description: 'Match storyboard drawings to video shots, arrange the shots, and guess transitions in Cocoa and Songly clips.',
    like: 'A hands-on editing room', type: 'iframe', gameUrl: '/games/StoryboardStudio/index.html', thumbnail: storyboardStudioImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 15, status: 'active',
    features: ['Storyboard Matching', 'Movie Sequencing', 'Guess the Transition', 'Camera & Editing'], requiresLogin: false,
    gameMode: 'teacher-led', tier: 'basic', playerCount: { min: 1, max: 100 }, musicalElements: [], musicalSkills: [],
  },

  'sky-flap': {
    id: 'sky-flap', title: 'Sky Flap',
    description: 'Guide a little bird safely through the cloud gates.',
    like: 'Flappy Bird', type: 'iframe', gameUrl: '/games/SkyFlap/index.html', thumbnail: skyFlapImg,
    category: 'general', difficulty: 'medium', cashReward: 20, estimatedPlayTime: 5, status: 'active',
    features: ['Timing', 'Focus', 'High Scores'], requiresLogin: false,
    gameMode: 'single-player', tier: 'basic', playerCount: 'single-player', musicalElements: [], musicalSkills: [],
  },

  'home-run-hero': {
    id: 'home-run-hero', title: 'Home Run Hero',
    description: 'Read each pitch, build a hit streak, and launch home runs in a 12-pitch derby.',
    like: 'Arcade Baseball', type: 'iframe', gameUrl: '/games/HomeRunHero/index.html', thumbnail: homeRunHeroImg,
    category: 'general', difficulty: 'medium', cashReward: 20, estimatedPlayTime: 5, status: 'active',
    features: ['Pitch Recognition', 'Timing', 'Combos'], requiresLogin: false,
    gameMode: 'single-player', tier: 'basic', playerCount: 'single-player', musicalElements: [], musicalSkills: [],
  },

  'emoji-match': {
    id: 'emoji-match', title: 'Emoji Match',
    description: 'Complete 10 levels, collect powered-up emojis, and build a five-emoji team.',
    like: 'Match 3', type: 'iframe', gameUrl: '/games/GemMatch/index.html', thumbnail: gemMatchImg,
    category: 'general', difficulty: 'easy', cashReward: 20, estimatedPlayTime: 5, status: 'active',
    features: ['10 Levels', 'Emoji Collection', 'Team Bonuses'], requiresLogin: false,
    gameMode: 'single-player', tier: 'basic', playerCount: 'single-player', musicalElements: [], musicalSkills: [],
  },

  'chordstruction': {
    id: 'chordstruction',
    title: 'Chordstruction',
    description: 'Learn chord progressions by building towers!',
    like: 'Tower Ball 3D',
    type: 'iframe',
    gameUrl: '/games/Chordstruction/index.html',
    thumbnail: chordstructionImg,
    category: 'general',
    difficulty: 'easy',
    cashReward: 20,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Fast-Paced', 'Chord Recognition'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: [],
    musicalSkills: ['composition', 'ear-training'],
  },

  // OG Creators – internal React-based creative prompting experience
  'og-creators': {
    id: 'og-creators',
    title: 'OG Creators (Beta)',
    description: 'Write creative prompts and ideas that your teacher can see in real time.',
    like: 'Shared Google Doc meets AI Playground',
    type: 'vanilla',
    gameUrl: undefined,
    thumbnail: defaultGameImage,
    category: 'general',
    difficulty: 'easy',
    cashReward: 0,
    estimatedPlayTime: 10,
    status: 'beta',
    features: ['Classroom Creative Prompts', 'Live Teacher View'],
    requiresLogin: true,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: { min: 1, max: 20 },
    musicalElements: [],
    musicalSkills: ['composition'],
  },

  'scale-the-tower': {
    id: 'scale-the-tower',
    title: 'Scale the Tower',
    description: 'Climb a perilous tower one note at a time!',
    like: 'Only Up! / Peak',
    type: 'iframe',
    gameUrl: '/games/ScaleTheTower/index.html',
    thumbnail: scaleImg,
    category: 'general',
    difficulty: 'easy',
    cashReward: 20,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Fast-Paced', 'Melodic'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['melody'],
    musicalSkills: ['ear-training'],
  },

  'overture-music-lab': {
    id: 'overture-music-lab',
    title: 'Overture Music Lab',
    description: 'A canvas for making your own song.',
    like: 'Song Maker',
    type: 'iframe',
    gameUrl: '/games/OvertureMusicLab/index.html',
    thumbnail: overtureMusicLabImg,
    category: 'rhythm',
    difficulty: 'easy',
    cashReward: 10,
    estimatedPlayTime: 15,
    status: 'active',
    features: ['Beat Making', 'Composition'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['rhythm','melody'],
    musicalSkills: ['composition']
  },


  'my-favorite-musicians': {
    id: 'my-favorite-musicians',
    title: 'My Favorite Musicians',
    description: 'A typing game to share your favorite artists and genres.',
    like: 'Spotify Wrapped',
    type: 'iframe',
    gameUrl: '/games/MyFavoriteMusicians/index.html',
    thumbnail: myFavoriteMusiciansImg,
    category: 'general',
    difficulty: 'easy',
    cashReward: 10,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Typing', 'Personalization'],
    requiresLogin: true,
    gameMode: 'single-player',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: [],
    musicalSkills: ['performance'],
  },

  'rhythm-puzzle': {
    id: 'rhythm-puzzle',
    title: 'Rhythm Puzzle',
    description: 'Crack rhythm codes to unlock the treasure! Teacher-led game where students clap patterns to break locks.',
    like: 'Rhythm Heaven',
    type: 'vanilla',
    gameUrl: '/games/RhythmPuzzle/index.html',
    thumbnail: RhythmPuzzle,
    category: 'rhythm',
    difficulty: 'medium',
    cashReward: 150,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Teacher-Led', 'Rhythm Recognition', 'Pattern Learning', 'Team Activity'],
    requiresLogin: false,
    gameMode: 'social-clubhouse',
    tier: 'basic',
    playerCount: { min: 1, max: 30 },
    musicalElements: ['rhythm'],
    musicalSkills: ['performance'],
  },

  'tune-testers': {
    id: 'tune-testers',
    title: 'Tune Testers',
    description: 'A fun game show that helps you distinguish between real melodies and random notes!',
    like: 'Roblox Guessing',
    type: 'vanilla',
    gameUrl: '/games/MelodyDiscovery/',
    thumbnail: tuneTestersImg,
    category: 'melody',
    difficulty: 'easy',
    cashReward: 15,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Game Show', 'Audio Examples', 'Aural Skills'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['melody', 'rhythm'],
    musicalSkills: ['ear-training'],
  },

  'melody-shaper': {
    id: 'melody-shaper',
    title: 'Melody Shaper',
    description: 'Listen to a melody and draw its shape to train your ear!',
    like: 'Skribbl.io art',
    type: 'vanilla',
    gameUrl: '/games/MelodyShaper/',
    thumbnail: melodyShaperImg,
    category: 'melody',
    difficulty: 'medium',
    cashReward: 20,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Aural Skills', 'Drawing', 'Melodic Contour'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['melody'],
    musicalSkills: ['ear-training'],
  },

  'step-skip-repeat': {
    id: 'step-skip-repeat',
    title: 'Step, Skip, or Repeat',
    description: 'A fun, energetic game where students identify melodic movement to make a character dance!',
    like: 'Simon Says',
    type: 'vanilla',
    gameUrl: '/games/StepSkipRepeat/',
    thumbnail: stepSkipRepeatImg,
    category: 'melody',
    difficulty: 'easy',
    cashReward: 10,
    estimatedPlayTime: 5,
    status: 'active',
    features: ['Animation', 'Teacher-Led', 'Sound Effects'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['melody'],
    musicalSkills: ['ear-training'],
  },

  'flappy-muse': {
    id: 'flappy-muse',
    title: 'Flappy Muse',
    description: 'Control the Muse with the dynamics of your voice.',
    like: 'Flappy Bird',
    type: 'iframe',
    gameUrl: '/games/FlappyMuse/index.html',
    thumbnail: flappyMuseImg,
    category: 'dynamics',
    difficulty: 'easy',
    cashReward: 50,
    estimatedPlayTime: 3,
    status: 'active',
    features: ['Voice Control', 'Aural Skills', 'Dynamics'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: { min: 1, max: 1 },
    musicalElements: ['dynamics'],
    musicalSkills: ['performance'],
  },
  
  'harmonidome-lab': {
    id: 'harmonidome-lab',
    title: 'Harmonidome Lab',
    description: 'Run an instrument lab! Sort instrument kits by family and serve customers the right instruments.',
    like: "Papa's Freezaria",
    type: 'vanilla',
    gameUrl: '/games/HarmonidomeLab/index.html',
    thumbnail: harmonidomeLabImg,
    category: 'instruments',
    difficulty: 'easy',
    cashReward: 50,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Instrument Families', 'Sorting', 'Time Management'],
    requiresLogin: false,
    gameMode: 'solo-leveling',
    tier: 'core',
    playerCount: 'single-player',
    musicalElements: ['instruments'],
    musicalSkills: ['ear-training'],
  },

  'soundgym-eq': {
    id: 'soundgym-eq',
    title: 'SoundGym EQ Game',
    description: 'Practice EQ by matching frequency changes to a target sound.',
    like: 'EQ Playground',
    type: 'iframe',
    gameUrl: 'https://www.soundgym.co/playground/test?t=eq&lp=eq',
    thumbnail: soundGymImg,
    category: 'dynamics',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Dynamics', 'Frequency Awareness'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['dynamics'],
    musicalSkills: ['performance']
  },
  
  'suno-ai': {
    id: 'suno-ai',
    title: 'Suno AI: Genre Song Generation',
    description: 'Generate songs with prompts and explore genre elements.',
    like: 'AI Music Tools',
    type: 'iframe',
    gameUrl: 'https://suno.com/',
    thumbnail: sunoImg,
    category: 'composition',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Composition', 'Genres'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['melody','rhythm'],
    musicalSkills: ['composition']
  },
  
  // Activity-to-Game conversions (all common/basic)
  'kahoot-intro': {
    id: 'kahoot-intro',
    title: 'Kahoot: Intro to Music',
    description: 'Interactive warm-up quiz to kick off music class.',
    like: 'Kahoot',
    type: 'iframe',
    gameUrl: 'https://create.kahoot.it/share/introduction-to-overture-games/1465b222-0cf7-41ef-88be-01ada7ac3c8e',
    thumbnail: kahootImg,
    category: 'general',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Warm-up', 'Quiz'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'basic',
    playerCount: { min: 1, max: 200 },
    musicalElements: ['rhythm','melody','harmony','instruments','form','dynamics'],
    musicalSkills: ['performance']
  },
  
  'instrument-families-explore': {
    id: 'instrument-families-explore',
    title: 'Instrument Families',
    description: 'Explore virtual instruments by family.',
    like: 'Virtual Piano',
    type: 'iframe',
    gameUrl: 'https://virtualpiano.net/virtual-music-instruments/',
    thumbnail: instrumentFamiliesImg,
    category: 'instruments',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 20,
    status: 'active',
    features: ['Exploration'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['instruments'],
    musicalSkills: ['performance']
  },
  'instruments-in-videos': {
    id: 'instruments-in-videos',
    title: 'Instruments in Videos',
    description: 'Identify instruments in curated videos.',
    like: 'YouTube',
    type: 'iframe',
    gameUrl: 'https://www.youtube.com/watch?v=5FCf7gEt3W8&list=PL-Kt6snleEJ9yCFxru8UgHSxlCbRFnW6L',
    thumbnail: instrumentsInVideosImg,
    category: 'instruments',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 15,
    status: 'active',
    features: ['Listening'],
    requiresLogin: false,
    gameMode: 'teacher-led',
    tier: 'basic',
    playerCount: { min: 1, max: 200 },
    musicalElements: ['instruments'],
    musicalSkills: ['performance']
  },
  'incredibox': {
    id: 'incredibox',
    title: 'Incredibox',
    description: 'Create music by dragging icons to animated beatboxers.',
    like: 'Incredibox',
    type: 'iframe',
    gameUrl: 'https://www.incredibox.com/demo/',
    thumbnail: incrediboxImg,
    category: 'composition',
    difficulty: 'easy',
    cashReward: 10,
    estimatedPlayTime: 15,
    status: 'active',
    features: ['Composition'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['rhythm','melody'],
    musicalSkills: ['composition']
  },
  'inside-the-orchestra': {
    id: 'inside-the-orchestra',
    title: 'Inside the Orchestra: Dynamic Game',
    description: 'Practice identifying dynamics in an interactive game.',
    like: 'Educational Mini-game',
    type: 'iframe',
    gameUrl: 'https://activities.insidetheorchestra.org/dynamic-game/',
    thumbnail: insideOrchestraImg,
    category: 'dynamics',
    difficulty: 'easy',
    cashReward: 5,
    estimatedPlayTime: 10,
    status: 'active',
    features: ['Dynamics'],
    requiresLogin: false,
    gameMode: 'single-player',
    tier: 'basic',
    playerCount: 'single-player',
    musicalElements: ['dynamics'],
    musicalSkills: ['performance']
  },
};

export const getGameById = (gameId: string): GameConfig | undefined => {
  return GAME_REGISTRY[gameId];
};

export const getGamesByCategory = (category: string): GameConfig[] => {
  return Object.values(GAME_REGISTRY).filter(game => game.category === category);
};

export const getActiveGames = (): GameConfig[] => {
  return Object.values(GAME_REGISTRY).filter(game => game.status === 'active');
};

export const getAvailableGames = (isLoggedIn: boolean): GameConfig[] => {
  return Object.values(GAME_REGISTRY).filter(game => 
    (game.status === 'active' || game.status === 'beta') && 
    (!game.requiresLogin || isLoggedIn)
  );
}; 
